/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Editor_Ai_ToolsInputs */

const cs_blog_editor_ai_tools = /** @type {(inputs: Blog_Editor_Ai_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI nástroje`)
};

const en_blog_editor_ai_tools = /** @type {(inputs: Blog_Editor_Ai_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI tools`)
};

/**
* | output |
* | --- |
* | "AI tools" |
*
* @param {Blog_Editor_Ai_ToolsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_editor_ai_tools = /** @type {((inputs?: Blog_Editor_Ai_ToolsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Editor_Ai_ToolsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_editor_ai_tools(inputs)
	return cs_blog_editor_ai_tools(inputs)
});